import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';
import {MdDialog, MdDialogRef} from '@angular/material';
import {SongDetailComponent} from '../../songs/song-detail/song-detail.component';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';


@Component({
  selector: 'data-table',
  templateUrl: './data-tables.component.html',
  styleUrls: ['./data-tables.component.css']
})
export class DataTablesComponent implements OnInit {
  @Input() columns: Array<any> = new Array<any>();
  @Input() data: Array<any> = new Array<any>();
  @Input() showSongActions: boolean = true;
  @Output() sortBy: EventEmitter<any> = new EventEmitter();
  private header: Array<any> = new Array<any>();
  temporaryData: Array<any> = new Array<any>();
  checkDataInTempData: boolean = false;
  liscensedData: Array<any> = new Array<any>();
  ownedData: Array<any> = new Array<any>();
  streamingData: Array<any> = new Array<any>();
  allObjects = new Domains('Display All Items', 'ALL');
  sortingRightsCheck: boolean = false;
  sortingRightsCheckBack: boolean = true;
  sortingRights: boolean = false;
  smallDevices: boolean = false;
  title: any = "";
  url: any = "";
  domains = [
    new Domains('Discover New Music', 'DM'),
    new Domains('Advanced Search', 'ASE'),
    new Domains('WeGet Official', 'wf'),
    new Domains('Radio', 'R'),
    new Domains('Most Played', 'MP'),
    new Domains('Most Downloaded', 'MD'),
    new Domains('Most Licensed', 'ML'),
    new Domains('Newest Music', 'NM'),
    new Domains('Music for Movies', 'M'),
    new Domains('Activity Playlists', 'AC'),
    new Domains('Fans Playlists', 'F'),
    new Domains('Business Playlists', 'B'),
    new Domains('Genre Playlists', 'G'),
    new Domains('My Playlists', 'P'),
    new Domains('My Music Collection', 'MC'),
    new Domains('My Radio', 'MR'),
    new Domains('My Discoveries', 'DS'),
    new Domains('Artist', 'A'),
    new Domains('Song', 'S'),
    new Domains('Collection', 'C'),
    new Domains('User Profile', 'U'),
    new Domains('Search', 'SE'),

  ];
  dialogRef: MdDialogRef<SongDetailComponent>;


  constructor(public dialog: MdDialog,private route: ActivatedRoute) {
  }


  ngOnInit() {

    this.route.queryParams.subscribe((queryParams: any) => {
      this.url = ""
      //this.getSongsByType();
    });
    if (this.columns.length > 0) {

      if(screen.width <= 1024) {
        for(let i=0; i< this.columns.length; i++){
          if(this.columns[i].title == "" || this.columns[i].title == "add-to-discover") {
            this.columns[i].width = "70px";
          }
            if(this.columns[i].title == "Artist" || this.columns[i].title == "Name"){
            this.columns[i].width = "130px";

              // if(this.columns[i].title == "Artist"){
                if(screen.width <= 360) {
                  this.columns[i].width = "90px";
                }
                if(this.route.snapshot.data['title'] && this.route.snapshot.data['title'] == "MyMusicLibrary"){
              if(this.columns[i].title == "Name") {
                if (screen.width > 360 && screen.width <= 767) {
                  this.columns[i].width = "170px";
                }
                }
                }
              // }
              // if(this.columns[i].title == "Name"){
              //   if(screen.width <= 360) {
              //     this.columns[i].width = "90px";
              //   }
              // }
          }

        }
        if(screen.width <= 360) {
          this.smallDevices = true;
        }
      }

      this.columns.forEach((arrayItem) => {
        let column = new Column();
        column.title = (arrayItem.type === 'text' || arrayItem.type === 'anchor' || arrayItem.type === 'date') ?
          arrayItem.title.toUpperCase() : arrayItem.title;
        column.key = arrayItem.key;
        column.type = arrayItem.type;
        column.width = arrayItem.width;
        column.responsiveIndex = arrayItem.responsiveIndex;
        if (typeof arrayItem.isSortable !== undefined && arrayItem.isSortable === false) {
          column.isSortable = arrayItem.isSortable;
        }
        column.textStyle = arrayItem.textStyle;

        this.header.push(column);
      });



    }

  }

  /**
   * getting streamingData
   */
  getStreamedData() {
    this.streamingData.length = 0;
    for (let i = 0; i < this.data.length; i++) {
      let row = this.data[i];
      if (row.item.isSongDownloaded == 'Licensed') {
        this.streamingData.push(row);
        console.log(row.item.isSongDownloaded);
      }
    }
    for (let i = 0; i < this.data.length; i++) {
      let row = this.data[i];
      if (row.item.isSongDownloaded == 'Owned') {
        this.streamingData.push(row);
        console.log(row.item.isSongDownloaded);
      }
    }
    for (let i = 0; i < this.data.length; i++) {
      let row = this.data[i];
      if (row.item.isSongDownloaded == 'Streaming') {
        this.streamingData.push(row);
        console.log(row.item.isSongDownloaded);
      }
    }
  }
  getStreamedData2() {
    this.streamingData.length = 0;
    for (let i = 0; i < this.data.length; i++) {
      let row = this.data[i];
      if (row.item.isSongDownloaded == 'Streaming') {
        this.streamingData.push(row);
        console.log(row.item.isSongDownloaded);
      }
    }
    for (let i = 0; i < this.data.length; i++) {
      let row = this.data[i];
      if (row.item.isSongDownloaded == 'Owned') {
        this.streamingData.push(row);
        console.log(row.item.isSongDownloaded);
      }
    }
    for (let i = 0; i < this.data.length; i++) {
      let row = this.data[i];
      if (row.item.isSongDownloaded == 'Licensed') {
        this.streamingData.push(row);
        console.log(row.item.isSongDownloaded);
      }
    }
  }
  /*****
   *
   * getting favurites by discveries
   *
   */
  getFavouritesDiscovered(dom) {
    this.temporaryData.length = 0;
    this.checkDataInTempData = false;
    if (dom == this.allObjects.domain) {
      return;
    }
    for (let i = 0; i < this.data.length; i++) {
      let row = this.data[i];
      for (let j = 0; j < this.header.length; j++) {
        let col: Column = this.header[j];
        this.getColumnValueForRow2(row, col, dom);
      }
    }
  }
  getColumnValueForRow2(row, col: Column, dom) {
    if (col.type == "icon") {
        return this.getNestedObjectIndexes2(row, col, dom);
    }
  }

  getNestedObjectIndexes2(row, col: Column, dom) {
    let a = col.key.split('.');
    let tempRow = row;
    for (let i = 0, n = a.length; i < n; ++i) {
      let k = a[i];
      if (row[k]) {
        row = row[k];
        if (dom === row.domain) {
          console.log(tempRow);
          this.temporaryData.push(tempRow);
        }
      } else {
        return '';
      }
    }
    if (this.temporaryData) {
      this.checkDataInTempData = true;
    }
    return row;
  }

  toggleControls(index) {
    this.data[index].isHovering = !this.data[index].isHovering;
  }


  /*****
   *
   * getting favurites by discveries
   *
   */
  getColumnValueForRow(row, col: Column) {
    let val='';
    if (col.key.split('.').length > 1) {
        val= this.getNestedObjectIndexes(row, col);
    } else {
      if (row[col.key]) {
          val= row[col.key];
      }
    }
    if((row.domain == "playlist") && col.key=="item.name"){
        val=this.getPlaylisName(row.item).toUpperCase()+":"+val;
    }
    return val;
  }
  getPlaylisName(item){
      //'A','P','R','Ac','G','M','B','F','DM'
      if (item.type === 'P' && (item.visibility).toLowerCase()!="system" && item.user_id == this.getLoggedInUserId()) {
       return "My Playlist"
      }else if(item.type === 'P' && (item.visibility).toLowerCase()=="system") {
          return "WeGet Favorites Playlist"
      }else if(item.type === 'R'){
          return "Radio"
      }else if(item.type === 'Ac'){
          return "Activity Playlist"
      }else if(item.type === 'G'){
          return "Genre Playlist"
      }else if(item.type === 'M'){
          return "Music for Movies Playlist"
      }else if(item.type === 'B'){
          return "Business Playlist"
      }else if(item.type === 'F'){
          return "Fans Playlist"
      }else if(item.type === 'DM'){
          return "Discover New Music Playlist"
      }else if(item.type === 'A'){
          return "Artist Playlist"
      }else {
          return "Playlist"
      }
  }

    getLoggedInUserId() {
        return (!!localStorage.getItem('user_id')) ? localStorage.getItem('user_id') : false;
    }

  getNestedObjectIndexes(row, col: Column) {
    let a = col.key.split('.');
    let tempRow = row;
    for (let i = 0, n = a.length; i < n; ++i) {
      let k = a[i];
      if (row[k]) {
        row = row[k];

      } else {
        return '';
      }

    }
    return row;
  }

  openSongDetail(song) {

    var width = '', height = '';
    var browserZoomLevel = Math.round(window.devicePixelRatio * 100);

    width = '37%';
    this.dialogRef = this.dialog.open(SongDetailComponent, {
      // disableClose: false,
      width: width
    });
    this.dialogRef.componentInstance.slug = song.slug;
    return false;
  }

  getAnchorUrl(row, col) {
    let urlHelper = (item, url) => {
      if (!item || !item._type || item == null || typeof item =="undefined") {
        return '';
      }
      if(col.type == "anchor" && col.title.toUpperCase() == "ARTIST"){
        if(item._type == "song"){
          url.push('/artist');
          url.push(item.artist.slug);
        }else if(item._type == 'playlist'){
          url.push('/playlist');
          url.push(item.slug);
        } else if(typeof item !="undefined" && typeof item.artist !="undefined" && typeof item.artist.slug !="undefined") {
          url.push('/artist');
          url.push(item.artist.slug);
        }
        return url;
      }

      if (item._type === 'playlist') {
        url.push('/playlist');
        url.push(item.slug);
      }
      // if (item._type === 'artist') {
      //   url.push('/artist');
      //   url.push(item.slug);
      // }
      if (item._type === 'song') {
        url.push('/song');
        url.push(item.slug);
      }
      if (item._type === 'album') {
        url.push('/collection');
        url.push(item.slug);
      }
      if (item._type === 'account') {
        url.push('/account');
        url.push(item.screenname);
      }

      return url;
    };

    let url = [];
    try{
      if (col.key.split('.').length > 1) {
        let item = row[col.key.split('.')[0]];
        urlHelper(item, url);
      } else {
        urlHelper(row, url);
      }
    }
    catch(err){
      console.log("Error was => "+err);
    }

    return url;
  }

  sort(column: Column) {
    console.log(column)
    if (column.title == 'RIGHTS' && column.key == "item.isSongDownloaded") {
      if (this.sortingRightsCheck == false && this.sortingRightsCheckBack == true) {
        this.sortingRights = true;
        this.sortingRightsCheck = true;
        this.sortingRightsCheckBack = false;
        this.getStreamedData();
        column.sortOrder = 1;
        this.header.forEach((arrayItem: Column) => {
          if (arrayItem.key !== "item.isSongDownloaded") {
            arrayItem.sortOrder = SORTORDER.UNSORTED;

          }
        });
        return;
      }
    }
    if (column.title == 'RIGHTS' && column.key == "item.isSongDownloaded") {

      if (this.sortingRightsCheck == true && this.sortingRightsCheckBack == false) {
        this.sortingRights = true;
        this.sortingRightsCheck = false;
        this.sortingRightsCheckBack = true;
        this.getStreamedData2();
        column.sortOrder = 2;
        return;
      }
    }


    this.sortingRights = false;
    if (column.isSortable === false) {
      return;
    }
    // toggle sort order for this column
    if (column.sortOrder === SORTORDER.UNSORTED) {
      column.sortOrder = SORTORDER.SORT_ASC;
    } else if (column.sortOrder === SORTORDER.SORT_ASC) {
      column.sortOrder = SORTORDER.SORT_DESC;
    } else if (column.sortOrder === SORTORDER.SORT_DESC) {
      column.sortOrder = SORTORDER.UNSORTED;
    }
    // reset sort order for others
    this.header.forEach((arrayItem: Column) => {
      if (arrayItem.key !== column.key) {
        arrayItem.sortOrder = SORTORDER.UNSORTED;

      }
    });
    this.sortBy.emit(column);
  }

  deleteFromLibrary(event) {
    _.remove(this.data, (arrayItem) => {
      return arrayItem.item.id === event.removed;
    });
  }

}

class Column {
  public title: string = '';
  public key: string = '';
  public type: string = '';
  public width: number = 10;
  public isSortable: boolean = true;
  public textStyle: any = {};
  public sortOrder: SORTORDER = SORTORDER.UNSORTED;
  public responsiveIndex: string = '';
}

enum SORTORDER {
  UNSORTED = 0,
  SORT_ASC = 1,
  SORT_DESC = 2
}
class Domains {
  constructor(public name: string, public domain: string) {

  }
}



// WEBPACK FOOTER //
// ./src/app/shared/data-tables/data-tables.component.ts